import { render, staticRenderFns } from "./StudentProfil.vue?vue&type=template&id=89a22ed0&"
import script from "./StudentProfil.vue?vue&type=script&lang=js&"
export * from "./StudentProfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports